import * as React from "react";
import { FormField } from "../../../../components/editors";
import { LoadingIcon, WrapperLess } from "../../../../components/generic";
import { ReactHelper } from "../../../../utils";

interface OwnProps {
    disableSubmit?: boolean;
    processing: boolean;
    onBack: () => void;
    onSave: (isSubmitLater: boolean) => void;
    onSkip: () => void;
    hideBack?: boolean;
    hideSkip?: boolean;
    hideSaveLater?: boolean;
    saveLabel?: string | JSX.Element;
}

export const ContinueButtons: React.SFC<OwnProps> = (props) => {

    const backBtn = props.hideBack || props.processing
        ? undefined
        : <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); props.onBack(); }}>&laquo; Back</a>;

    const skipBtn = props.hideSkip
        ? undefined
        : <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); props.onSkip(); }}>Skip for now</a>;

    const saveLaterBtn = props.hideSaveLater
        ? undefined
        : <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); props.onSave(true); }}>
            Save and submit later
        </a>;

    const submitBtnText = props.saveLabel ? props.saveLabel : <WrapperLess>Continue &raquo;</WrapperLess>;

    const submitBtn = props.disableSubmit
        ? <span className="action disabled">
            {submitBtnText}
        </span>
        : <a className="action" href="#" onClick={(e) => { ReactHelper.emptyClick(e); props.onSave(false); }}>
            {submitBtnText}
        </a>;

    const details = props.processing
        ? <div className="form-actions">
            <div className="form-actions-primary">
                <span className="action">
                    <LoadingIcon /> Saving&hellip;
                </span>
            </div>
        </div>
        : <div className="form-actions">
            <div className="form-actions-primary">
                {submitBtn}
                {skipBtn}
            </div>
            <div className="form-actions-primary">
                {saveLaterBtn}
            </div>
        </div>;

    return <FormField name="" labelChildren={backBtn}>{details}</FormField>;
};



// WEBPACK FOOTER //
// ./src/containers/abstracts/composer/components/ContinueButtons.tsx